import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import { resetPassword } from '../../Api';

function NewPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const canAccess = sessionStorage.getItem('canAccessReset') === 'true';
  useEffect(() => {
    if (!canAccess) {
      navigate('/forgot-password');
    }
    sessionStorage.removeItem('canAccessValidate');
  }, [canAccess, navigate]);

  const email = location.state?.email;

  const [formData, setFormData] = useState({
    email: email,
    password: '',
    confirmPassword: '',
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    const { password, confirmPassword } = formData;

    // Validation checks
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return;
    }

    try {
      await resetPassword({ email, password });
      setSuccessMessage('Password reset successful. Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000); 
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message || 'Error resetting password.');
      } else {
        setError('Error resetting password.');
      }
    }
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Jasa Indonesia Perdana Logo" className="logo" />
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="password"
            name="password"
            placeholder="New Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-group">
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm New Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit">Reset Password</button>
      </form>

      {successMessage && <p className="success">{successMessage}</p>}
      {error && <p className="error">{error}</p>}
    </div>
  );
}

export default NewPassword;
